const getTrailIdByTag = (tag, trails) =>
  trails.find((trail) => trail.tag === tag)?.id

export default getTrailIdByTag
